import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = ["id", "href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["for"]
const _hoisted_9 = ["for"]
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 2,
  class: "m-0"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  id: "field-help",
  class: "p-error"
}
const _hoisted_14 = {
  key: 0,
  class: "flex justify-content-center p-4"
}
const _hoisted_15 = ["onSubmit"]
const _hoisted_16 = ["id", "href"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_19 = { class: "mt-0 mb-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["for"]
const _hoisted_25 = ["for"]
const _hoisted_26 = { key: 12 }
const _hoisted_27 = { class: "grid" }
const _hoisted_28 = { class: "col-6 text-left pl-2" }
const _hoisted_29 = { class: "col-6 text-right pr-2" }
const _hoisted_30 = { key: 13 }
const _hoisted_31 = ["disabled", "name", "id", "accepts", "onChange"]
const _hoisted_32 = { class: "attachment" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  id: "field-help",
  class: "p-error"
}
const _hoisted_36 = {
  key: 0,
  class: "flex justify-content-center p-4 mb-8"
}

import { ref, watch, computed, onMounted, reactive, registerRuntimeCompiler } from "vue";
import { useRoute } from 'vue-router'
import { useSurvey } from "@/composables/useSurvey";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import SurveyThankYouPage from "./SurveyThankYouPage.vue";
// import { useRecaptcha } from "@/composables/useRecaptcha";
import surveyService from "@/services/SurveyService";
import { useAppCustomizations } from '@/composables/useAppCustomizations';
import AppCustomizationsModel from '@/models/AppCustomizationsModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'Survey',
  setup(__props) {

_useCssVars(_ctx => ({
  "1bcfefe0": (buttonTextColor.value),
  "b506f5a2": (buttonBackgroundColor.value)
}))

const toast = useToast();

const { fetchSurvey, getLookups, sendSubmission, checkUniqueAnswer } = useSurvey();
const route = useRoute();
// const { recaptchaSiteKey } = useRecaptcha();
const { getAppCustomizations } = useAppCustomizations();

const fetchCompleted = ref<boolean>(false);

const validation = ref<any>({});
const privacyConsentGiven = ref<boolean>(false);
const sent = ref<boolean>(false);
const submitting = ref<boolean>(false);
const requestIdOrPublicUrl = ref<string>('');
const lang = ref<any>(null);
const fullSurvey = ref<any>(null);
const userId = ref<number | null>(null);
const buId = ref<number | null>(null);
const answers = ref<any>({ questions: {} });
var oldAnswersPrivacy: any = null;
var oldAnswersQuestions: any = null;
const uniqueWarningMessage = ref<string>('');
const mainErrorMessage = ref<string>('');
const surveyAlreadySentMessage = ref<string>('');
const submissionSent = ref<any>(null);

const buttonBackgroundColor = ref<string>('');
const buttonTextColor = ref<string>('');

const boolOptions: Array<any> = [true, false];

const lookups = ref<any>({
    cities: []
});

const showSentPreview = computed(() => sent.value && !survey.value.isPreview);
const showMainErrorMessage = computed(() => mainErrorMessage.value != '');
const showUniqueWarning = computed(() => uniqueWarningMessage.value != '');
const showSurveyAlreadySentMessage = computed(() => surveyAlreadySentMessage.value != '');

const questions = computed((): Array<any> => {
    let thisQuestions: Array<any> = [];

    if (survey.value) {
        survey.value.pages.forEach((page: any) => {
            page.forEach((question: any) => {
                if (question.questionType.type == 'webService') {
                    question.ws = {
                        results: []
                    };
                }

                thisQuestions.push(question);
            });
        });
    }

    return thisQuestions;
});

const survey = computed(() => {
    if (!fullSurvey.value || !lang.value) {
        return null;
    }

    var chosenLang = lang.value.language;

    return fullSurvey.value.localization.find((loc: any) => {
        return loc.language === chosenLang;
    })
});

const socialUrls = computed<any>(() => {
    if (!fullSurvey.value) {
        return null;
    }

    return {
        instagramUrl: fullSurvey.value.instagramUrl,
        youTubeUrl: fullSurvey.value.youTubeUrl,
        twitterUrl: fullSurvey.value.twitterUrl,
        facebookUrl: fullSurvey.value.facebookUrl
    } as any;
});

const langList = computed(() => {
    if (!fullSurvey.value)
        return [];

    return fullSurvey.value.localization.map((loc: any) => {
        return {
            language: loc.language,
            languageText: loc.languageText
        }
    });
});

watch(survey, () => {
    if (survey.value != null)
        initAnswers()
});

var oldUniqueTimeout: number | null = null;

watch(answers, () => {
    if (oldAnswersPrivacy != null) {
        for (const answPrivacy in answers.value.privacy) {
            const thisAnswerPrivacy = answers.value.privacy[answPrivacy];

            if (oldAnswersPrivacy[answPrivacy]) {
                if (thisAnswerPrivacy.value != oldAnswersPrivacy[answPrivacy].value) {
                    validatePrivacy(thisAnswerPrivacy);
                }
            }
        }
    }

    if (oldUniqueTimeout)
        clearTimeout(oldUniqueTimeout);

    if (oldAnswersQuestions != null) {
        for (const answQuestion in answers.value.questions) {
            const thisAnswer = answers.value.questions[answQuestion];

            if (oldAnswersQuestions[answQuestion]) {
                if (thisAnswer.value != oldAnswersQuestions[answQuestion].value) {

                    if (thisAnswer && thisAnswer.value != '') {
                        oldUniqueTimeout = setTimeout(() => {
                            // check unique
                            const thisQuestion = questions.value.find(q => q.questionId == answQuestion);
                            checkUniqueAnswerModel(thisQuestion, thisAnswer.value);
                        }, 300);
                    }

                    validateAnswer(thisAnswer);
                }
            }
        }
    }

    oldAnswersPrivacy = {};
    oldAnswersQuestions = {};

    for (const answPrivacy in answers.value.privacy) {
        oldAnswersPrivacy[answPrivacy] = {
            value: answers.value.privacy[answPrivacy].value
        };
    }

    for (const answQuestion in answers.value.questions) {
        oldAnswersQuestions[answQuestion] = {
            value: answers.value.questions[answQuestion].value
        };
    }

}, { deep: true });

const validatePrivacy = (privacyAnswer: any): any => {
    const privacy = survey.value.privacy.find((p: any) => p.privacyId == privacyAnswer.privacyId);
    const validationEntry = validation.value.privacy[privacyAnswer.privacyId];

    validationEntry.error = false;
    validationEntry.errorMessage = '';

    if (privacy.mandatory) {
        switch (privacy.confirmation.type) {
            case 'check':
                validationEntry.error = (privacyAnswer.value !== true && privacyAnswer.value !== 'checked');
                if (validationEntry.error) {
                    validationEntry.errorMessage = 'Spuntare la casella per poter procedere con il questionario';
                }

                break;
            case 'accept-deny':
                validationEntry.error = privacyAnswer.value != 'accept';
                if (validationEntry.error) {
                    validationEntry.errorMessage = 'Dare il consenso per poter procedere con il questionario';
                }

                break;
        }
    }

    return validationEntry;
};

const validateAnswer = (answer: any): any => {
    const question = questions.value.find(q => q.questionId == answer.questionId);
    const answerValue = answer.value;
    const validationEntry = validation.value.questions[answer.questionId];

    validationEntry.error = false;
    validationEntry.errorMessage = "";

    switch (question.questionType.type) {
        case 'number':
        case 'slider':
        case 'rating':
            // deve essere numero
            if (answerValue) {
                if (isNaN(answerValue)) {
                    validationEntry.error = true;
                    validationEntry.errorMessage = "La risposta deve essere numerica";
                }
                else {
                    const valueNumber = Number(answerValue);

                    if (question.validation.min && valueNumber < question.validation.min) {
                        validationEntry.error = true;
                        validationEntry.errorMessage = "La risposta deve essere maggiore di " + question.validation.min;
                    }

                    if (question.validation.max && valueNumber > question.validation.max) {
                        validationEntry.error = true;
                        validationEntry.errorMessage = "La risposta deve essere minore di " + question.validation.max;
                    }
                }
            }

            break;

        case 'date':
            if (answerValue && !(answerValue instanceof Date)) {
                validationEntry.error = true;
                validationEntry.errorMessage = "La risposta deve essere una data";
            }
            break;

        case 'bool':
            // verifico che il tipo della risposta sia booleano
            if (answerValue != null && answerValue != undefined && answerValue !== true && answerValue !== false) {
                validationEntry.error = true;
                validationEntry.errorMessage = "Risposta non valida";
            }
            break;

        case 'multiCheck':
            if (question.validation) {
                if (question.validation.mandatory && (!answerValue || answerValue.length == 0)) {
                    validationEntry.error = true;
                    validationEntry.errorMessage = "La risposta è obbligatoria";
                }
                else if (question.validation.maxChoices && answerValue.length > question.validation.maxChoices) {
                    validationEntry.error = true;
                    validationEntry.errorMessage = `E' possibile selezionare al massimo ${question.validation.maxChoices} risposte`;
                }
            }

            break;

        case 'email':
            if (!new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$/).test(answerValue)) {
                validationEntry.error = true;
                validationEntry.errorMessage = "L'indirizzo e-mail non è valido";
            }
            break;

        case 'attachment':
            if (question.validation.mandatory && (!answerValue || answerValue.length == 0)) {
                validationEntry.error = true;
                validationEntry.errorMessage = "La risposta è obbligatoria";
            } else if (question.validation.maxChoices && answerValue.length > question.validation.maxChoices) {
                validationEntry.error = true;
                validationEntry.errorMessage = `E' possibile selezionare al massimo ${question.validation.maxChoices} allegati`;
            } else if ((question.fileType == "image" && answerValue && !answerValue.every((a: any) => a.type?.startsWith("image/"))) ||
                (question.fileType == "pdf" && answerValue && !answerValue.every((a: any) => a.type == "application/pdf")) ||
                (question.fileType == "custom" && answerValue && !answerValue.every((a: any) => question.fileExtensions?.includes(a.name?.substring(a.name?.lastIndexOf(".")))))) {
                validationEntry.error = true;
                validationEntry.errorMessage = "Un file allegato ha un'estensione non valida";
            } else if (answerValue && !answerValue.every((a: any) => a.size <= (question.maxFileSize || 5) * 1024 * 1024)) {
                validationEntry.error = true;
                validationEntry.errorMessage = "La dimensione degli allegati deve essere minore di " + (question.maxFileSize || 5) + " MB";
            }
            break;

        default:
            // testo libero
            if (question.validation.regex) {
                if (!new RegExp(question.validation.regex).test(answerValue)) {
                    validationEntry.error = true;
                    validationEntry.errorMessage = "La risposta non è in formato valido";
                }
            }

            break;
    }

    if (question.validation && question.validation.mandatory) {
        if (question.questionType.type != 'multiCheck' && !answerValue) {
            validationEntry.error = true;
            validationEntry.errorMessage = "La domanda è obbligatoria";
        }
    }

    return validationEntry;
}

const initAnswers = () => {
    answers.value = {
        privacy: {},
        masterData: {},
        questions: {}
    };

    validation.value = {
        privacy: {},
        questions: {}
    };

    privacyConsentGiven.value = false;
    if (survey.value && survey.value.privacy) {
        survey.value.privacy.forEach((privacy: any) => {
            var id = privacy.privacyId;

            answers.value.privacy[id] = {};
            answers.value.privacy[id].privacyId = id;
            answers.value.privacy[id].value = null;

            validation.value.privacy[id] = {};
            validation.value.privacy[id].privacyId = id;
            validation.value.privacy[id].error = false;
            validation.value.privacy[id].errorMessage = '';
        });

        // se non ci sono privacy, vado direttamente al questionario
        if (!survey.value.privacy || !(survey.value.privacy instanceof Array) ||
            survey.value.privacy.length == 0) {
            privacyConsentGiven.value = true;
        }
    }

    questions.value.forEach((question: any) => {
        var id = question.questionId;

        answers.value.questions[id] = {};
        answers.value.questions[id].questionId = id;
        answers.value.questions[id].value = question.questionType.type === 'multiCheck' || question.questionType.type == 'attachment' ? [] : null;

        validation.value.questions[id] = {};
        validation.value.questions[id].questionId = id;
        validation.value.questions[id].error = false;
        validation.value.questions[id].errorMessage = '';
    });

    if (survey.value && survey.value.requestMasterData) {
        survey.value.requestMasterData.forEach((masterData: any) => {
            var fieldId = masterData.field;

            answers.value.masterData[fieldId] = {};
            answers.value.masterData[fieldId].field = fieldId;
            answers.value.masterData[fieldId].value = null;
            answers.value.masterData[fieldId].error = false;
            answers.value.masterData[fieldId].errorMessage = '';
        });
    }
};

const getRatingArray = (question: any) => {
    let outArr: Array<number> = [];

    for (let i = question.validation.min; i <= question.validation.max; ++i) {
        outArr.push(i);
    }

    return outArr;
}

const searchWsQuestion = (event: any, question: any) => {
    axios.get(question.webServiceUrl + '?q=' + event.query)
        .then((res) => {
            question.ws.results = res.data;
        });
};

const onWsOptionSelected = (event: any, question: any) => {
    // scan di tutte le domande per sostituire i valori
    if (question.autofillFieldName && question.autofillFieldName != '' &&
        event.value[question.autofillFieldName]) {
        answers.value.questions[question.questionId].value = event.value[question.autofillFieldName];
    }
    else {
        answers.value.questions[question.questionId].value = event.query;
    }

    questions.value.forEach(thisQuestion => {
        if (thisQuestion.autofillFieldName && thisQuestion.autofillFieldName != '' &&
            event.value[thisQuestion.autofillFieldName]) {
            let selValue: any = event.value[thisQuestion.autofillFieldName];

            if (thisQuestion.questionType.type == 'multiCheck') {
                answers.value.questions[thisQuestion.questionId].value.splice(0, answers.value.questions[thisQuestion.questionId].value.length);
                answers.value.questions[thisQuestion.questionId].push(selValue);
            }
            else {
                answers.value.questions[thisQuestion.questionId].value = selValue;
            }
        }
    });
};

const getAttachmentFileType = (question: any) => {
    switch (question.fileType) {
        case "image":
            return "image/*";
        case "pdf":
            return "application/pdf"
        case "custom":
            if (question.fileExtensions) {
                const extensions = String(question.fileExtensions).split(",");
                return extensions.map(ext => {
                    let s = ext.trim();
                    if (!s.startsWith(".")) s = "." + s;
                    return s;
                });
            } else {
                return undefined
            }
        case "all":
        default:
            return undefined;
    }
};

const onSelectAttachment = (question: any, event: any) => {
    const files = [...event.target.files];
    const attachments = answers.value.questions[question.questionId].value;

    for (const file of files) {
        const index = attachments.findIndex((a: any) => a.name == file.name);
        if (index >= 0) {
            // sovrascrivo file
            attachments.splice(index, 1);
        }

        attachments.push(file);
    }

    event.target.value = "";
};

const onRemoveAttachment = (question: any, file: any) => {
    const attachments = answers.value.questions[question.questionId].value;

    const index = attachments.findIndex((a: any) => a.name == file.name);

    if (index >= 0) attachments.splice(index, 1);
};

const getProcessedAnswers = async () => {
    return {
        surveyId: fullSurvey.value.surveyId,
        language: survey.value.language,
        timestamp: new Date().toISOString(),
        deviceId: 'WEB',
        privacy: await getAnswerArray(answers.value.privacy),
        answers: await getAnswerArray(answers.value.questions),
        masterData: await getAnswerArray(answers.value.masterData)
    }
};

const getAnswerArray = async (answersObj: any) => {
    var answerArray: Array<any> = [];

    for (const item of Object.values<any>(answersObj)) {
        if (questions.value.find(q => q.questionId == item.questionId)?.questionType?.type == "attachment") {
            const attachments = await Promise.all(item.value.map(async (file: any) => ({
                file: await toBase64(file),
                extension: file.name.substring(file.name.lastIndexOf(".") + 1)
            })));

            answerArray.push({
                ...item,
                value: attachments
            });
        } else {
            answerArray.push(item);
        }
    }
    return answerArray;
};

const toBase64 = (file: any) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});

const onSubmitPrivacy = () => {
    let validationSuccess = true;
    let scrollToError = true;

    for (let privacyId in answers.value.privacy) {
        const privacyAnswer = answers.value.privacy[privacyId];
        const validationResult = validatePrivacy(privacyAnswer);

        if (validationResult.error) {
            validationSuccess = false;

            if (scrollToError) {
                scrollToError = false;
                var questionError = document.getElementById("privacy_" + validationResult.privacyId);
                questionError?.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    if (!validationSuccess) {
        toast.add({ severity: 'error', summary: 'Attenzione', detail: 'Fornire i consensi necessari per poter proseguire', life: 3000 });
        submitting.value = false;
    }
    else {
        // simulo invio survey per preview
        privacyConsentGiven.value = true;

        // cambio il valore delle privacy checkbox da true/false a 'checked'/'unchecked'
        for (let privacyId in answers.value.privacy) {
            const privacyAnswer = answers.value.privacy[privacyId].value;
            const privacy = survey.value.privacy.find((p: any) => p.privacyId == privacyId);

            if (privacy.confirmation.type == 'check') {
                answers.value.privacy[privacyId].value = privacyAnswer == true ? 'checked' : 'unchecked';
            }
        }
    }
};

const onSubmitQuestions = async () => {
    try {
        submitting.value = true;

        mainErrorMessage.value = '';
        toast.removeAllGroups();

        let validationSuccess = true;
        let scrollToError = true;

        for (let questionId in answers.value.questions) {
            const answer = answers.value.questions[questionId];
            const validationResult = validateAnswer(answer);

            if (validationResult.error) {
                validationSuccess = false;

                if (scrollToError) {
                    scrollToError = false;
                    var questionError = document.getElementById("question_" + validationResult.questionId);
                    questionError?.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }

        if (!validationSuccess) {
            toast.add({ severity: 'error', summary: 'Attenzione', detail: 'Ci sono errori nella compilazione delle risposte', life: 3000 });
            submitting.value = false;
        } else if (fullSurvey.value.isPreview) {
            // simulo invio survey per preview
            sent.value = true;
            submitting.value = false;
        } else {
            for (let i = 0; i < questions.value.length; i++) {
                const question = questions.value[i];

                if (answers.value.masterData) {
                    if (question.autofillFieldName == 'ragioneSociale') {
                        if (answers.value.masterData['companyName']) {
                            answers.value.masterData['companyName'].value = answers.value.questions[question.questionId].value;
                        }
                    }
                    else if (question.autofillFieldName == 'nomeContatto') {
                        if (answers.value.masterData['firstName']) {
                            answers.value.masterData['firstName'].value = answers.value.questions[question.questionId].value;
                        }
                    }
                    else if (question.autofillFieldName == 'cognomeContatto') {
                        if (answers.value.masterData['lastName']) {
                            answers.value.masterData['lastName'].value = answers.value.questions[question.questionId].value;
                        }
                    }
                }
            }

            // validazione recaptcha prima di inviare il submit
            // (grecaptcha as any).enterprise.ready(async () => {
            //     const recaptchaToken = await (grecaptcha as any).enterprise.execute(recaptchaSiteKey, {action: 'LOGIN'});
            const recaptchaToken = "";
            // IMPORTANT: The 'token' that results from execute is an encrypted response sent by
            // reCAPTCHA Enterprise to the end user's browser.
            // This token must be validated by creating an assessment.
            // See https://cloud.google.com/recaptcha-enterprise/docs/create-assessment

            var resJson = await getProcessedAnswers();

            const res = await sendSubmission(requestIdOrPublicUrl.value, recaptchaToken, resJson);

            sent.value = true;

            // sostituisce base64 a fileName se allegato è tipo immagine
            questions.value.filter(q => q.questionType.type == 'attachment' && q.fileType == "image").forEach(question => {
                const surveyAnswers = res.surveyAnswers.filter((a: any) => a.questionId == question.questionId);
                const base64Answers = resJson.answers.find(a => a.questionId == question.questionId).value;

                if (base64Answers && surveyAnswers.length == base64Answers.length) {
                    for (let i = 0; i < surveyAnswers.length; i++) {
                        if (base64Answers[i].file) surveyAnswers[i].answer = base64Answers[i].file;
                    }
                }
            });

            submissionSent.value = res;

            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
    } catch (err: any) {
        if (err?.response?.data?.messages && err?.response?.data?.messages != "") {
            mainErrorMessage.value = err.response.data.messages;
        } else if (err?.code == "ERR_NETWORK" || err?.code == "ETIMEDOUT" || err?.code == "ECONNABORTED") {
            mainErrorMessage.value = "Si è verificato un errore nell\'invio della risposta. Assicurati di avere buona connessione a internet e riprova.";
        } else {
            mainErrorMessage.value = 'Si è verificato un errore nell\'invio della risposta. Riprova più tardi.';
        }

        submitting.value = false;
    }
};

const closePage = () => {
    try {
        if (window.opener) {
            window.opener.location.href = window.opener.location.href;
        }
    } catch {
        // do nothing
    }

    window.close();
};

const checkUniqueAnswerModel = (question: any, answer: any): void => {
    if (!question.validation.uniqueAnswer)
        return;

    checkUniqueAnswer(fullSurvey.value.surveyId, question.questionId, answer)
        .then((res) => {
            if (!res) {
                uniqueWarningMessage.value = `${question.question}: la risposta "${answer}" è già presente in un altro questionario inviato. Questa domanda non consente risposte duplicate.`;
            }
        });
};

const downloadQuestionAttachment = async (attachment: any): Promise<void> => {
    const file = await surveyService.downloadQuestionAttachment(attachment.file);

    const href = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', attachment.fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

const getQuestionGroupClass = (question: any) => {
    var s = "";

    if (question.questionGroup == '' || question.questionGroup == null) {
        // non è parte di un gruppo
        return s;
    }

    var previousQuestion = questions.value[questions.value.findIndex(q => q.questionId == question.questionId) - 1];
    if (previousQuestion?.questionGroup == question.questionGroup) {
        // ci sono altre domande dello stesso gruppo prima
        s += "question-group-before ";
    }
    
    var nextQuestion = questions.value[questions.value.findIndex(q => q.questionId == question.questionId) + 1];
    if (nextQuestion?.questionGroup == question.questionGroup) {
        // ci sono altre domande dello stesso gruppo dopo
        s += "question-group-after";
    }

    return s;
}

onMounted(async () => {
    fetchCompleted.value = false;

    // aggiunge script recaptcha
    // let recaptchaScript = document.createElement('script')
    // recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/enterprise.js?render=' + recaptchaSiteKey)
    // document.head.appendChild(recaptchaScript)

    requestIdOrPublicUrl.value = route.query.id ? route.query.id.toString() : route.path;

    const customizations = await getAppCustomizations();
    buttonBackgroundColor.value = customizations?.buttonBackgroundColorRgb;
    buttonTextColor.value = customizations?.buttonTextColorRgb;

    if (!requestIdOrPublicUrl.value) {
        mainErrorMessage.value = "Questionario sconosciuto";
        return;
    }

    await fetchSurvey(requestIdOrPublicUrl.value).then((resSurvey) => {
        getLookups()
            .then((resLookups) => {
                lookups.value.cities = resLookups.cities;

                fullSurvey.value = resSurvey.survey;
                userId.value = resSurvey.currentUserId;
                buId.value = resSurvey.currentBusinessUnitId;

                if (fullSurvey.value.selectedLanguages.length == 1) {
                    lang.value = langList.value.find((l: any) => l.language == fullSurvey.value.defaultLanguage);
                }
            })
            .catch(err => {
                mainErrorMessage.value = err;
            });

    }).catch(err => {
        switch (err.response.status) {
            case 410:
                // GONE: questionario già inviato per questo destinatario
                surveyAlreadySentMessage.value = "Il questionario è già stato compilato";
                break;
            case 404:
                // NOT FOUND: il questionario o il destinatario non esiste
                mainErrorMessage.value = "Questionario non trovato";
                break;
            case 401:
                // UNAUTHORIZED: il questionario non è compilabile dall'utente
                mainErrorMessage.value = "Non si hanno i permessi per la compilazione del questionario";
                break;
            default:
                mainErrorMessage.value = "Parametri errati per il caricamento del questionario";
                break;
        }
    });

    fetchCompleted.value = true;
});



return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!fetchCompleted.value)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "initial-loading"
        }))
      : _createCommentVNode("", true),
    (sent.value && submissionSent.value)
      ? (_openBlock(), _createBlock(SurveyThankYouPage, {
          key: 1,
          submission: submissionSent.value,
          survey: survey.value,
          socialUrls: socialUrls.value
        }, null, 8, ["submission", "survey", "socialUrls"]))
      : (fetchCompleted.value && !survey.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (langList.value && fullSurvey.value)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  class: "p-fluid mt-3"
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(" Benvenuti su Smart Survey ")
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_Dropdown, {
                      modelValue: lang.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lang).value = $event)),
                      options: langList.value,
                      "option-label": "languageText",
                      placeholder: "Selezionare la lingua"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (fetchCompleted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_Card, { class: "survey-title" }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(survey.value.title), 1)
                ]),
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(survey.value.description), 1)
                ]),
                _: 1
              }),
              (!privacyConsentGiven.value)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _withModifiers(onSubmitPrivacy, ["prevent"])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(survey.value.privacy, (privacy) => {
                      return (_openBlock(), _createBlock(_component_Card, {
                        key: "'privacy_' + privacy.privacyId",
                        class: "p-fluid"
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("a", {
                            id: 'privacy_' + privacy.privacyId,
                            href: 'privacy_' + privacy.privacyId,
                            tabindex: "-1"
                          }, null, 8, _hoisted_6),
                          _createTextVNode(" " + _toDisplayString(privacy.text) + " ", 1),
                          (privacy.mandatory)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        content: _withCtx(() => [
                          (privacy.confirmation.type == 'check')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["field-checkbox", { 'p-invalid': validation.value.privacy[privacy.privacyId].error }])
                              }, [
                                _createVNode(_component_Checkbox, {
                                  name: 'privacy_' + privacy.privacyId,
                                  id: 'privacy_' + privacy.privacyId + '_checked',
                                  binary: true,
                                  modelValue: answers.value.privacy[privacy.privacyId].value,
                                  "onUpdate:modelValue": ($event: any) => ((answers.value.privacy[privacy.privacyId].value) = $event)
                                }, null, 8, ["name", "id", "modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("label", {
                                  for: 'privacy_' + privacy.privacyId + '_checked'
                                }, _toDisplayString(privacy.confirmation.checkText), 9, _hoisted_8)
                              ], 2))
                            : _createCommentVNode("", true),
                          (privacy.confirmation.type == 'accept-deny')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["field-radiobutton", { 'p-invalid': validation.value.privacy[privacy.privacyId].error }])
                              }, [
                                _createVNode(_component_RadioButton, {
                                  name: 'privacy_' + privacy.privacyId,
                                  id: 'privacy_' + privacy.privacyId + '_accept',
                                  value: "accept",
                                  modelValue: answers.value.privacy[privacy.privacyId].value,
                                  "onUpdate:modelValue": ($event: any) => ((answers.value.privacy[privacy.privacyId].value) = $event)
                                }, null, 8, ["name", "id", "modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("label", {
                                  for: 'privacy_' + privacy.privacyId + '_accept'
                                }, _toDisplayString(privacy.confirmation.acceptText), 9, _hoisted_9),
                                _createVNode(_component_RadioButton, {
                                  name: 'privacy_' + privacy.privacyId,
                                  id: 'privacy_' + privacy.privacyId + '_deny',
                                  class: "ml-3",
                                  value: "deny",
                                  modelValue: answers.value.privacy[privacy.privacyId].value,
                                  "onUpdate:modelValue": ($event: any) => ((answers.value.privacy[privacy.privacyId].value) = $event)
                                }, null, 8, ["name", "id", "modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("label", {
                                  for: 'privacy_' + privacy.privacyId + '_deny'
                                }, _toDisplayString(privacy.confirmation.denyText), 9, _hoisted_10)
                              ], 2))
                            : _createCommentVNode("", true),
                          (privacy.url || privacy.linkText)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                _createElementVNode("a", {
                                  href: privacy.url,
                                  target: "_blank"
                                }, _toDisplayString(privacy.linkText), 9, _hoisted_12)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("small", _hoisted_13, _toDisplayString(validation.value.privacy[privacy.privacyId].errorMessage), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (fullSurvey.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_Toast),
                          _createVNode(_component_Button, {
                            type: "submit",
                            label: "PROSEGUI",
                            class: "pl-8 pr-8 font-bold"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_5))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _withModifiers(onSubmitQuestions, ["prevent"])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question) => {
                      return (_openBlock(), _createBlock(_component_Card, {
                        key: "'question_' + question.questionId",
                        class: _normalizeClass(["p-fluid", getQuestionGroupClass(question)])
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("a", {
                            id: 'question_' + question.questionId,
                            href: 'question_' + question.questionId,
                            tabindex: "-1"
                          }, null, 8, _hoisted_16),
                          _createTextVNode(" " + _toDisplayString(question.questionId) + ". " + _toDisplayString(question.question) + " ", 1),
                          (question.validation.mandatory)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        content: _withCtx(() => [
                          (question.questionAttachments.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("p", _hoisted_19, _toDisplayString(question.questionAttachments.length == 1 ? 'Allegato' : 'Allegati') + ": ", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.questionAttachments, (attachment, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: question.questionId + '-' + i
                                  }, [
                                    (attachment.file.startsWith('data:image/'))
                                      ? (_openBlock(), _createBlock(_component_Image, {
                                          key: 0,
                                          src: attachment.file,
                                          alt: attachment.fileName,
                                          width: "250",
                                          preview: ""
                                        }, null, 8, ["src", "alt"]))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (downloadQuestionAttachment(attachment)), ["prevent"])
                                        }, _toDisplayString(attachment.fileName.substring(0, attachment.fileName.lastIndexOf('.'))), 9, _hoisted_20))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'text')
                            ? (_openBlock(), _createBlock(_component_Textarea, {
                                key: 1,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                rows: 1,
                                "auto-resize": true,
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'email')
                            ? (_openBlock(), _createBlock(_component_InputText, {
                                key: 2,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                type: "text",
                                placeholder: "E-mail",
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'bool')
                            ? (_openBlock(), _createBlock(_component_SelectButton, {
                                key: 3,
                                options: boolOptions,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, {
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_21, [
                                    (slotProps.option)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Sì"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_23, "No"))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'number')
                            ? (_openBlock(), _createBlock(_component_InputNumber, {
                                key: 4,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                "use-grouping": false,
                                inputClass: validation.value.questions[question.questionId].error ? 'p-invalid' : '',
                                disabled: submitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "inputClass", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'slider')
                            ? (_openBlock(), _createBlock(_component_Slider, {
                                key: 5,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                step: 1,
                                min: question.validation.min,
                                max: question.validation.max,
                                orientation: "horizontal",
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'date')
                            ? (_openBlock(), _createBlock(_component_Calendar, {
                                key: 6,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                "date-format": 'dd/mm/yy',
                                placeholder: 'es: 31/05/' + new Date().getFullYear(),
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'combo')
                            ? (_openBlock(), _createBlock(_component_Dropdown, {
                                key: 7,
                                options: question.questionType.parameters,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                "option-value": "value",
                                "option-label": "label",
                                filter: true,
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'radio')
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 8 }, _renderList(question.questionType.parameters, (parameter, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["field-radiobutton", { 'p-invalid': validation.value.questions[question.questionId].error }]),
                                  key: question.questionId + '_' + index
                                }, [
                                  _createVNode(_component_RadioButton, {
                                    modelValue: answers.value.questions[question.questionId].value,
                                    "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                    id: 'q_' + question.questionId + '_' + index,
                                    name: 'question_' + question.questionId,
                                    value: parameter.value,
                                    disabled: submitting.value
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "name", "value", "disabled"]),
                                  _createElementVNode("label", {
                                    for: 'q_' + question.questionId + '_' + index,
                                    class: "ml-2"
                                  }, _toDisplayString(parameter.label), 9, _hoisted_24)
                                ], 2))
                              }), 128))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'multiCheck')
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 9 }, _renderList(question.questionType.parameters, (questionParam) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["field-checkbox", { 'p-invalid': validation.value.questions[question.questionId].error }]),
                                  key: 'question_' + question.questionId + '_' + questionParam.value
                                }, [
                                  _createVNode(_component_Checkbox, {
                                    name: 'question_' + question.questionId,
                                    id: 'question_' + question.questionId + '_' + questionParam.value,
                                    value: questionParam.value,
                                    modelValue: answers.value.questions[question.questionId].value,
                                    "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                    disabled: submitting.value || answers.value.questions[question.questionId].value.indexOf(questionParam.value) < 0 && question.validation.maxChoices && answers.value.questions[question.questionId].value.length == question.validation.maxChoices
                                  }, null, 8, ["name", "id", "value", "modelValue", "onUpdate:modelValue", "disabled"]),
                                  _createElementVNode("label", {
                                    for: 'question_' + question.questionId + '_' + questionParam.value
                                  }, _toDisplayString(questionParam.label), 9, _hoisted_25)
                                ], 2))
                              }), 128))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'cities')
                            ? (_openBlock(), _createBlock(_component_Dropdown, {
                                key: 10,
                                options: lookups.value.cities,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                "option-value": "value",
                                "option-label": "label",
                                filter: true,
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'webService')
                            ? (_openBlock(), _createBlock(_component_AutoComplete, {
                                key: 11,
                                modelValue: answers.value.questions[question.questionId].value,
                                "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                suggestions: question.ws.results,
                                field: question.autofillFieldName,
                                "min-length": 3,
                                onComplete: ($event: any) => (searchWsQuestion($event, question)),
                                onItemSelect: ($event: any) => (onWsOptionSelected($event, question)),
                                class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                disabled: submitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "field", "onComplete", "onItemSelect", "class", "disabled"]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'rating')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                _createVNode(_component_SelectButton, {
                                  options: getRatingArray(question),
                                  modelValue: answers.value.questions[question.questionId].value,
                                  "onUpdate:modelValue": ($event: any) => ((answers.value.questions[question.questionId].value) = $event),
                                  class: _normalizeClass({ 'p-invalid': validation.value.questions[question.questionId].error }),
                                  disabled: submitting.value
                                }, {
                                  option: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.option), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["options", "modelValue", "onUpdate:modelValue", "class", "disabled"]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, _toDisplayString(question.minValueLabel), 1),
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(question.maxValueLabel), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (question.questionType.type == 'attachment')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("input", {
                                  multiple: "",
                                  disabled: submitting.value,
                                  type: "file",
                                  name: 'question_' + question.questionId,
                                  id: 'question_' + question.questionId,
                                  accepts: getAttachmentFileType(question),
                                  onChange: ($event) => onSelectAttachment(question, $event)
                                }, null, 40, _hoisted_31),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value.questions[question.questionId].value, (file) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(file.name), 1),
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pi pi-times no-underline ml-3",
                                      onClick: _withModifiers(($event: any) => (onRemoveAttachment(question, file)), ["prevent"])
                                    }, null, 8, _hoisted_34)
                                  ]))
                                }), 256))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("small", _hoisted_35, _toDisplayString(validation.value.questions[question.questionId].errorMessage), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128)),
                    (fullSurvey.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_component_Toast),
                          (submitting.value)
                            ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                                key: 0,
                                class: "survey-submit-loading"
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                type: "submit",
                                label: "INVIA",
                                class: "pl-8 pr-8 font-bold",
                                disabled: submitting.value
                              }, null, 8, ["disabled"]))
                        ]))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_15)),
              _createVNode(_component_Dialog, {
                header: survey.value.thankYouPage.title,
                visible: showSentPreview.value,
                "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showSentPreview).value = $event)),
                breakpoints: { '960px': '75vw', '640px': '90vw' },
                style: { width: '50vw' },
                modal: true,
                closable: false
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: "Ok",
                    icon: "pi pi-check",
                    onClick: closePage,
                    autofocus: ""
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Message, {
                    severity: "success",
                    closable: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(survey.value.thankYouPage.text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["header", "visible"]),
              _createVNode(_component_Dialog, {
                header: 'Attenzione',
                visible: showUniqueWarning.value,
                "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showUniqueWarning).value = $event)),
                breakpoints: { '960px': '75vw', '640px': '90vw' },
                style: { width: '50vw' },
                modal: true,
                closable: true
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: "Ok",
                    icon: "pi pi-check",
                    autofocus: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {uniqueWarningMessage.value = '';})
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Message, {
                    severity: "error",
                    closable: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(uniqueWarningMessage.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]))
          : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      header: 'Attenzione',
      visible: showMainErrorMessage.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showMainErrorMessage).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' },
      modal: true,
      closable: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          autofocus: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => {mainErrorMessage.value = '';})
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(mainErrorMessage.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: 'Grazie!',
      visible: showSurveyAlreadySentMessage.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((showSurveyAlreadySentMessage).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' },
      modal: true,
      closable: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          autofocus: "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => {surveyAlreadySentMessage.value = '';})
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          severity: "success",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(surveyAlreadySentMessage.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})